import React, { Component, PropTypes } from 'react'
import { reduxForm } from 'redux-form'

import { getSetupformFields, getImageId, isUploadingImage, getNewVenue } from 'selectors/setupform'
import { getEventTypes } from 'selectors/entities'
import { getFeatureFlag } from 'selectors/settings'
import LoadingSpinner from 'components/loading-spinner'
import validate from 'utils/validate'

import SetupformForm from './setupform-form'
import EVENT_FIELDS from './fields'

import SetupformVoucherForm from './setupform-voucher-form'
import VOUCHER_FIELDS from './voucher-fields'

export function createSetupFormContainer(FormComponent) {
  const result = class SetupformFormContainer extends Component {
    render() {
      if (this.props.loading) {
        return <LoadingSpinner />
      }

      return (
        <FormComponent fields={this.props.fields} />
      )
    }
  }

  result.propTypes = {
    fields: PropTypes.object,
    loading: PropTypes.bool,
  }

  return result
}

export function createMapStateToProps(fieldNames) {
  return (state, ownProps) => {
    const initialValues = getSetupformFields(ownProps.setupformId, fieldNames)(state)
    const eventTypes = getEventTypes(state)

    return {
      initialValues,
      imageId: getImageId(state),
      isUploadingImage: isUploadingImage(state),
      loading: initialValues === null || !eventTypes,
      newVenue: getNewVenue(state),
      newVenueCreation: getFeatureFlag('portal_setupform_new_venue_creation')(state),
    }
  }
}

export function createReduxSetupFormContainer(FormComponent, fieldMetadata) {
  const fields = fieldMetadata
  const fieldNames = fieldMetadata.map(f => f.name)
  const mapStateToProps = createMapStateToProps(fieldNames)
  const component = createSetupFormContainer(FormComponent)

  return reduxForm({
    form: 'setupform',
    fields: fields.map(field => field.name),
    validate: validate(fields),
  }, mapStateToProps)(component)
}


export const SetupformEventFormContainer = createReduxSetupFormContainer(SetupformForm, EVENT_FIELDS)
export const SetupformVoucherFormContainer = createReduxSetupFormContainer(SetupformVoucherForm, VOUCHER_FIELDS)



/** WEBPACK FOOTER **
 ** ./src/components/setupform-form/setupform-form-container.js
 **/